import axios from 'axios';
import config from "../config";

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getJournalStock = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );

    return axios.get(`${DOMAIN}/api/rapport/journal-stock`, { params: clean });
};

export const getDashboardStock = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );
    return axios.get(`${DOMAIN}/api/rapport/dashboard_stock`, { params: clean });
};

export const getFicheProduit = async(id) => {
    return axios.get(`${DOMAIN}/api/rapport/fiche_produit`, {
      params : {
        id_produit : id
      }
    })
};

export const getAnalyseVenteParType = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            if (Array.isArray(value)) {
                value.forEach(item => queryParams.append(key, item));
            } else {
                queryParams.append(key, value);
            }
        }
    });
    
    const url = `${DOMAIN}/api/rapport/analyse_venteParType${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axios.get(url);
    return response;
};

export const getMonthlyFlux = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );
    return axios.get(`${DOMAIN}/api/rapport/monthly-flux`, { params: clean });
};

export const getMonthlyFluxByProduct = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );
    return axios.get(`${DOMAIN}/api/rapport/monthly-flux/product`, { params: clean });
};

export const getFifoAnalysis = (idVarianteProduit) => {
    return axios.get(`${DOMAIN}/api/rapport/fifo-analysis`, {
        params: { idVarianteProduit }
    });
};

export const postRebuildFifo = (idVarianteProduit) => {
    return axios.post(`${DOMAIN}/api/rapport/rebuild-fifo`, null, {
        params: { idVarianteProduit }
    });
};

export const getLotRotationAnalysis = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );
    return axios.get(`${DOMAIN}/api/rapport/lot-rotation`, { params: clean });
};
// --- Module Rapports décisionnels V1 -----------------------------------------
const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
);

// GET /api/rapport/produits/performance (admin)
// GET /api/rapport/premium/clients (admin) — rapport Clientes premium.
// GET /api/rapport/premium/relance (admin) — « Qui relancer cette semaine » (RFM).
export const getRelanceRfm = () =>
  axios.get(`${DOMAIN}/api/rapport/premium/relance`);

// GET /api/rapport/premium/fidelisation (admin) — nouvelles vs fidèles, cohortes.
export const getFidelisation = () =>
  axios.get(`${DOMAIN}/api/rapport/premium/fidelisation`);

export const getClientsRapport = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/premium/clients`, { params: cleanParams(params) });

// GET /api/rapport/premium/revenus (admin) — série mensuelle, N-1, YTD.
export const getRevenusRapport = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/premium/revenus`, { params: cleanParams(params) });

// GET /api/rapport/premium/approvisionnement (admin) — balance entrées/sorties.
export const getApproRapport = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/premium/approvisionnement`, { params: cleanParams(params) });

// GET /api/rapport/produits/ventes (admin) — rapport Ventes premium.
export const getVentesRapport = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/ventes`, { params: cleanParams(params) });

export const getProductPerformance = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/performance`, { params: cleanParams(params) });

// GET /api/rapport/vendeurs (admin) — ventes au COMPTOIR par personne, avec le
// rappel de ses ventes en livraison (lecture d'un profil mixte d'un coup d'œil).
export const getVentesParVendeur = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/vendeurs`, { params: cleanParams(params) });

// GET /api/rapport/produits/ruptures (admin)
export const getProductRuptures = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/ruptures`, { params: cleanParams(params) });

// GET /api/rapport/produits/rotation (admin)
export const getProductRotation = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/rotation`, { params: cleanParams(params) });

// GET /api/rapport/produits/dormants (admin)
export const getProductDormants = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/dormants`, { params: cleanParams(params) });

// GET /api/rapport/produits/pointures (admin)
export const getProductPointures = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/pointures`, { params: cleanParams(params) });

// GET /api/rapport/produits/decisions (admin)
export const getProductDecisions = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/decisions`, { params: cleanParams(params) });

// GET /api/rapport/produits/dimensions (admin) — analyse par couleur/marque/
// catégorie/matière (part ventes vs part stock, moteur des pointures).
export const getProductDimensions = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/dimensions`, { params: cleanParams(params) });

// GET /api/rapport/produits/ventes-manquees (admin) — CA perdu faute de stock.
export const getVentesManquees = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/ventes-manquees`, { params: cleanParams(params) });

// GET /api/rapport/produits/retours (admin) — essais & retours par modèle.
export const getEssaisRetours = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/retours`, { params: cleanParams(params) });

// GET /api/rapport/premium/zones (admin) — clientes et CA par commune.
export const getGeoZones = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/premium/zones`, { params: cleanParams(params) });

// GET /api/rapport/produits/anciennete (admin) — CA par ancienneté du stock
// (millésime + fraîcheur du CA, base premier référencement).
export const getStockAgeRevenue = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/anciennete`, { params: cleanParams(params) });

// GET /api/rapport/produits/apercu (admin) — vue d'ensemble du module Rapports
export const getProductOverview = (params = {}) =>
  axios.get(`${DOMAIN}/api/rapport/produits/apercu`, { params: cleanParams(params) });
